import "../css/footer.css";

import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCcVisa,
  FaCcMastercard,
  FaCcPaypal
} from "react-icons/fa";

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";


function Footer() {


  const [footer, setFooter] = useState({});


  useEffect(() => {

    loadFooter();

  }, []);



  const loadFooter = async () => {

    try {

      const res = await axios.get(
        `${API_URL}/footer`
      );

      setFooter(res.data);

    }

    catch(err){

      console.log(
        "Footer Load Error",
        err
      );

    }

  };



  return (

    <footer className="footer">


      <div className="footer-container">


        {/* Company */}

        <div className="footer-column">


          <h2>
            {footer.company_name || "SIPS LIQUOR"}
          </h2>


          <p>

            Premium destination for Whiskey,
            Wine, Beer, Vodka, Tequila,
            Champagne and Fine Spirits.
            Delivering quality beverages with
            exceptional customer service.

          </p>



          <div className="social-links">


            <a href={footer.facebook} target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>


            <a href={footer.instagram} target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>


            <a href={footer.twitter} target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>


            <a href={footer.youtube} target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>


          </div>


        </div>




        {/* Quick Links */}

        <div className="footer-column">


          <h3>
            Quick Links
          </h3>


          <Link to="/">
            Home
          </Link>


          <Link to="/shop">
            Shop
          </Link>


          <Link to="/categories">
            Categories
          </Link>


          <Link to="/about">
            About Us
          </Link>


          <Link to="/contact">
            Contact Us
          </Link>


        </div>




        {/* Categories */}

        <div className="footer-column">


          <h3>
            Categories
          </h3>


          <Link to="/shop?category=Whiskey">
            Whiskey
          </Link>


          <Link to="/shop?category=Wine">
            Wine
          </Link>


          <Link to="/shop?category=Beer">
            Beer
          </Link>


          <Link to="/shop?category=Vodka">
            Vodka
          </Link>


          <Link to="/shop?category=Champagne">
            Champagne
          </Link>


          <Link to="/shop?category=Tequila">
            Tequila
          </Link>


        </div>





        {/* Customer Service */}

        <div className="footer-column">


          <h3>
            Customer Service
          </h3>


          <Link to="/faq">
            FAQ
          </Link>


          <Link to="/track-order">
            Track Order
          </Link>


          <Link to="/shipping-policy">
            Shipping Policy
          </Link>


          <Link to="/return-policy">
            Return Policy
          </Link>


        </div>





        {/* Legal */}

        <div className="footer-column">


          <h3>
            Legal
          </h3>


          <Link to="/privacy-policy">
            Privacy Policy
          </Link>


          <Link to="/terms">
            Terms & Conditions
          </Link>


        </div>





        {/* My Account */}

        <div className="footer-column">


          <h3>
            My Account
          </h3>


          <Link to="/profile">
            My Profile
          </Link>


          <Link to="/my-orders">
            My Orders
          </Link>


          <Link to="/addresses">
            Addresses
          </Link>


          <Link to="/wishlist">
            Wishlist
          </Link>


        </div>






        {/* Contact */}


        <div className="footer-column">


          <h3>
            Contact Us
          </h3>



          <p>

            <FaMapMarkerAlt />

            {footer.address ||
            "323 N New Braunfels Ave ste 102, San Antonio, Texas 78202"}

          </p>




          <p>

            <FaPhoneAlt />

            {footer.phone ||
            "+1 (210) 248-9916"}

          </p>




          <p>

            <FaEnvelope />

            {footer.email ||
            "sipsliquor@shopat1stop.com"}

          </p>



          <h4>
            Store Hours
          </h4>


          <p>
            Mon - Sat : 9:00 AM - 10:00 PM
          </p>


          <p>
            Sunday : 10:00 AM - 8:00 PM
          </p>



        </div>



      </div>





      <hr />





      <div className="footer-bottom">


        <div className="payments">


          <FaCcVisa />

          <FaCcMastercard />

          <FaCcPaypal />


        </div>




        <p>

          {footer.copyright ||
          "© 2026 SIPS LIQUOR. All Rights Reserved."}

        </p>



      </div>



    </footer>

  );

}


export default Footer;